export const SBOTD_TYPE = 'sbotd';
export const PRO_TYPE = 'pro';

export const SBOTD_PATH = 'SpecialBuyOfTheDay';
export const PRO_PATH = 'ProSpecialBuyOfTheWeek';
export const DAILY_DEALS_PATH = 'daily-deals';

export const isSbotd = (specialBuyType) => specialBuyType === SBOTD_TYPE;
export const isPro = (specialBuyType) => specialBuyType === PRO_TYPE;

export const getPreviewDateFromParams = (search) => {
  const searchParams = new URLSearchParams(search);
  if (searchParams.has('previewDate')) {
    return searchParams.get('previewDate');
  }

  return null;
};

export const getSpecialBuyTypeFromPath = (pathname) => {
  if (pathname.includes(PRO_PATH)) return PRO_TYPE;
  if (pathname.includes(SBOTD_PATH) || pathname.includes(DAILY_DEALS_PATH)) return SBOTD_TYPE;
  return null;
};

export const getMetadata = (specialBuyType) => {
  try {
    let canonicalURL = '/SpecialBuy/SpecialBuyOfTheDay';
    if (typeof window !== 'undefined' && window.location.pathname === '/daily-deals') {
      canonicalURL = '/daily-deals';
    }
    switch (specialBuyType) {
    case PRO_TYPE:
      return {
        title: 'Pro Special Buy Of The Week: Find The Deal Of The Week at The Home Depot',
        // eslint-disable-next-line max-len
        description: 'Find the deal of the week and save on select Pro items with Home Depot\'s Pro Special Buy of The Week.',
        canonicalURL: '/SpecialBuy/ProSpecialBuyOfTheWeek',
        type: 'sbotd',
        siteName: 'The Home Depot',
        facebookAdmins: '100005416960152'
      };
    case SBOTD_TYPE:
      return {
        title: 'Daily Deals: Find The Deal Of The Day at The Home Depot',
        // eslint-disable-next-line max-len
        description: 'Find the deal of the day and save on select appliances, décor, and home improvement items with Home Depot\'s Daily Deals.',
        canonicalURL,
        mobile: 'android-app://com.thehomedepot/homedepot/sbotd',
        type: 'sbotd',
        siteName: 'The Home Depot',
        facebookAdmins: '100005416960152'
      };
    default:
      return null;
    }
  } catch (err) {
    console.error('Error fetching special buy metadata:', err);
    return null;
  }
};
